import React, { Component, Fragment } from 'react';
import injectSheet from 'react-jss';

import { Button } from '~/eds/src/components/Button/Button';
import { injectIntl } from 'react-intl';

import EcModalCard from '../../Shared/EcModalCard/EcModalCard';
import EcSelect from '../../Shared/EcSelect/EcSelect';
import CloseIcon from '../../Shared/Icons/CloseIcon';
import styles from './SearchWithinProvisionModal.styles';

class SearchWithinProvisionModal extends Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleActionClick = this.handleActionClick.bind(this);
    this.handleAddTextFilter = this.handleAddTextFilter.bind(this);
    this.handleRemoveTextFilter = this.handleRemoveTextFilter.bind(this);

    this.searchWordsContainOptions = [
      {
        value: 'contains',
        label: props.intl.formatMessage({
          id: 'SearchWithinProvisionModal.containsOption',
          defaultMessage: 'contains',
          description: 'Search contains option label',
        }),
      },
      {
        value: 'does_not_contain',
        label: props.intl.formatMessage({
          id: 'SearchWithinProvisionModal.doesNotContainOption',
          defaultMessage: 'does not contain',
          description: 'Search does not contain option label',
        }),
      },
    ];
    this.searchWordsScopeOptions = [
      {
        value: 'all_of_these_words',
        label: props.intl.formatMessage({
          id: 'SearchWithinProvisionModal.allOfTheseWordsOption',
          defaultMessage: 'all of these words',
          description: 'Search scope all words option label',
        }),
      },
      {
        value: 'any_of_these_words',
        label: props.intl.formatMessage({
          id: 'SearchWithinProvisionModal.anyOfTheseWordsOption',
          defaultMessage: 'any of these words',
          description: 'Search scope any words option label',
        }),
      },
      {
        value: 'exact_phrase',
        label: props.intl.formatMessage({
          id: 'SearchWithinProvisionModal.exactPhraseOption',
          defaultMessage: 'exact phrase',
          description: 'Search scope exact phrase option label',
        }),
      },
    ];

    this.state = {
      filterOptions: {
        filterContains: this.searchWordsContainOptions[0],
        filterScope: this.searchWordsScopeOptions[0],
        filterPhrase: '',
      },
      textFilters: this.props.filter.textSearch || [],
    };
  }

  handleInputChange(event) {
    this.setState({
      filterOptions: {
        ...this.state.filterOptions,
        filterPhrase: event.target.value,
      },
    });
  }

  handleActionClick() {
    const { handleUpdateFilter, filterIndex, filter, hideModal } = this.props;
    const {
      filterOptions: { filterPhrase },
      textFilters,
    } = this.state;

    if (filterPhrase.length) {
      this.setState({ addButtonHighlighted: true });
    } else {
      handleUpdateFilter(filterIndex, { ...filter, textSearch: textFilters });
      hideModal();
    }
  }

  handleAddTextFilter() {
    const { filterOptions } = this.state;

    this.setState((prevState) => ({
      textFilters: [...prevState.textFilters, filterOptions],
      filterOptions: {
        ...prevState.filterOptions,
        filterPhrase: '',
      },
      addButtonHighlighted: false,
    }));
  }

  handleRemoveTextFilter(index) {
    let newTextFilters = [...this.state.textFilters];
    newTextFilters.splice(index, 1);

    this.setState({ textFilters: newTextFilters });
  }

  renderSearchFilters() {
    const { classes } = this.props;
    const { textFilters } = this.state;

    return textFilters.map((filter, index) => (
      <div key={`text-filter-${index}`} className={classes.filterRow}>
        <hr className={classes.textSearchRowSeparator} />
        <div className={classes.searchOptions}>
          <div className={classes.textSearchSelectItem}>
            {filter.filterContains.label}
          </div>
          <div className={classes.textSearchSelectItem}>
            {filter.filterScope.label}
          </div>
          <div className={classes.textSearchInputItem}>
            {filter.filterPhrase}
          </div>
          <button
            className={classes.textSearchRemoveButton}
            onClick={() => this.handleRemoveTextFilter(index)}
          >
            <CloseIcon size="20" />
          </button>
        </div>
        <hr className={classes.textSearchRowSeparator} />
      </div>
    ));
  }

  renderTextSearchOptions() {
    const { classes, intl } = this.props;
    const { filterOptions, addButtonHighlighted } = this.state;

    const inputPlaceholder =
      filterOptions.filterScope.value === 'exact_phrase'
        ? intl.formatMessage({
            id: 'SearchWithinProvisionModal.typePhrasePlaceholder',
            defaultMessage: 'type in a phrase…',
            description: 'Placeholder for exact phrase input',
          })
        : intl.formatMessage({
            id: 'SearchWithinProvisionModal.spaceSeperatedWordsPlaceholder',
            defaultMessage: 'space-separated list of words',
            description: 'Placeholder for space-separated words input',
          });

    return (
      <Fragment>
        <div className={classes.textSearchSelectItem}>
          <EcSelect
            options={this.searchWordsContainOptions}
            value={filterOptions.filterContains}
            onChange={(option) =>
              this.setState({
                filterOptions: {
                  ...this.state.filterOptions,
                  filterContains: option,
                },
              })
            }
          />
        </div>
        <div className={classes.textSearchSelectItem}>
          <EcSelect
            options={this.searchWordsScopeOptions}
            value={filterOptions.filterScope}
            onChange={(option) =>
              this.setState({
                filterOptions: {
                  ...this.state.filterOptions,
                  filterScope: option,
                },
              })
            }
          />
        </div>
        <div className={classes.textSearchInputItem}>
          <div className={classes.inputContainer}>
            <input
              type="text"
              placeholder={inputPlaceholder}
              value={filterOptions.filterPhrase}
              onChange={this.handleInputChange}
            />
          </div>
        </div>
        <div className={classes.textSearchOptionItem}>
          <Button
            text={intl.formatMessage({
              id: 'SearchWithinProvisionModal.addButton',
              defaultMessage: 'Add',
              description: 'Add button text',
            })}
            onClick={this.handleAddTextFilter}
            disabled={!filterOptions.filterPhrase.length}
            highlighted={
              addButtonHighlighted ? addButtonHighlighted.toString() : ''
            }
          />
        </div>
      </Fragment>
    );
  }

  renderAddButtonNotClickedMessage() {
    const { classes, intl } = this.props;

    return (
      <div className={classes.errorMessage}>
        {intl.formatMessage({
          id: 'SearchWithinProvisionModal.addButtonNotClickedMessage',
          defaultMessage: 'Select "Add" to add the text search filter.',
          description: 'Error message when add button is not clicked',
        })}
      </div>
    );
  }

  render() {
    const { classes, title, hideModal, filter, intl } = this.props;
    const { addButtonHighlighted } = this.state;

    return (
      <EcModalCard
        title={title}
        content={
          <>
            {addButtonHighlighted && this.renderAddButtonNotClickedMessage()}
            <div className={classes.provisionLabel}>
              {intl.formatMessage({
                id: 'SearchWithinProvisionModal.provisionLabel',
                defaultMessage: 'PROVISION',
                description: 'Provision section label',
              })}
            </div>
            <div className={classes.provisionType}>
              {filter.filterValue.label}
            </div>
            <div className={classes.searchLabel}>
              {intl.formatMessage({
                id: 'SearchWithinProvisionModal.searchLabel',
                defaultMessage: 'SEARCH WITHIN SELECTED PROVISION',
                description: 'Search section label',
              })}
            </div>
            <div className={classes.searchOptions}>
              {this.renderTextSearchOptions()}
            </div>
            <div className={classes.searchFilters}>
              {this.renderSearchFilters()}
            </div>
          </>
        }
        footer={
          <>
            <Button
              variant="tertiary"
              text={intl.formatMessage({
                id: 'SearchWithinProvisionModal.cancelButton',
                defaultMessage: 'Cancel',
                description: 'Cancel button text',
              })}
              onClick={hideModal}
            />
            <Button
              variant="primary"
              text={intl.formatMessage({
                id: 'SearchWithinProvisionModal.searchWithinClauseButton',
                defaultMessage: 'Search Within Clause',
                description: 'Search within clause button text',
              })}
              onClick={this.handleActionClick}
            />
          </>
        }
        hideModal={hideModal}
      />
    );
  }
}

export default injectSheet(styles)(injectIntl(SearchWithinProvisionModal));
